import { render, staticRenderFns } from "./CMSTemplateList.vue?vue&type=template&id=b759003a&"
import script from "./CMSTemplateList.vue?vue&type=script&lang=js&"
export * from "./CMSTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports